import {
    ButtonType, ButtonWidget,
    InteractionState,
} from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { Loadable, LoadingStatus } from '~src/httpClient/utils/Loadable';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

import { IBroadcastDetail } from '../models/IBroadcastContentInfo';
import { BroadcastViewDetailDialog } from './BroadcastViewDetailDialog';

const BROADCAST_BUTTON_ICON_TEST_ID = 'broadcast-icon';
export class BroadcastButton extends React.PureComponent<BroadcastButtonProps, BroadcastButtonStates> {

    constructor(props: BroadcastButtonProps) {
        super(props);
        this.state = { showingDialog: false };
    }

    public render() {
        return (
            <>
                <ButtonWidget
                    buttonType={ButtonType.IconOutline}
                    style={{ cursor: 'pointer' }}
                    testId={BROADCAST_BUTTON_ICON_TEST_ID}
                    getContent={this.buttonContent}
                    handleClick={this.toggleDialogVisibility}
                />
                {this.state.showingDialog && this.getBroadcastViewDetailDialog()}
            </>
        );
    }

    private buttonContent = (interactionState: InteractionState): JSX.Element => {
        const iconPath = this.getIconPath();
        const backgroundColor = { backgroundColor: (interactionState.hover ? '#ebebeb' : 'transparent') };
        return (
            <span className={PageHeaderStyles.TextButton} style={backgroundColor}>
                <img src={imgPath(iconPath)}
                    style={PageHeaderStyles.iconOnlyButton}
                    alt={Messages.broadcastIcon()} />
            </span>
        );
    };

    private getIconPath = () => {
        const isBroadcast = !!this.props.broadcastStatus.content;
        // display base icon when error occurs to broadcast that broadcast is not load, this should not happen
        let iconPath = `spaces_viz_view_header_broadcast_base_20px.svg`;
        // display current status of broadcast
        if (this.props.broadcastStatus.loadingStatus !== LoadingStatus.NOT_LOADED) {
            iconPath = isBroadcast ? `spaces_viz_view_header_broadcast_on_20px.svg` : `spaces_viz_view_header_broadcast_off_20px.svg`;
        }
        return iconPath;
    };

    private toggleDialogVisibility = () => {
        this.setState((prev) => {
            return { showingDialog: !prev.showingDialog };
        });
    };

    private hideDialog = () => {
        this.setState({ showingDialog: false });
    };

    private getBroadcastViewDetailDialog = () => {
        return (<BroadcastViewDetailDialog
            broadcastStatus={this.props.broadcastStatus}
            broadcastDetail={this.props.broadcastDetail}
            onCreateBroadcast={this.props.onCreateBroadcast}
            onDeleteBroadcast={this.props.onDeleteBroadcast}
            onCloseRequest={this.hideDialog}
            viewName={this.props.viewName} />);
    };
}

export interface BroadcastButtonProps {
    readonly broadcastStatus: Loadable<boolean>;
    readonly broadcastDetail: Loadable<IBroadcastDetail>;
    readonly viewName: string;
    onCreateBroadcast: () => void;
    onDeleteBroadcast: () => void;
    getBroadcastDetail: () => void;
}

export interface BroadcastButtonStates {
    readonly showingDialog: boolean;
}